let numeros = {
  titulo: "Nossos ",
  descricao: "Em mais de 30 anos de história, a Cromo vem ajudando milhares de balsenses a realizar o sonho de seu lote ou casa própria e contribuindo no desenvolvimento do Sul do Maranhão..",
  lotes: 1200,
  asfalto: 2600,
  rua: 140,
  familias: 700
};

export default numeros;